import React, { ReactElement } from "react";

type Props = {
  value?: string | React.ReactElement | false | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  extraClasses?: string;
  icon?: ReactElement | false | undefined;
  iconPosition?: "start" | "end";
  extraProps?: React.ComponentProps<"button">;
  isPending?: boolean;
  type?: "submit" | "button"
};

const ButtonStyled = ({
  value,
  onClick,
  extraClasses,
  icon,
  iconPosition,
  extraProps,
  isPending,
  type
}: Props) => {
  return (
    <button
      onClick={onClick}
      {...extraProps}
      disabled={isPending}
      type={type ? type : 'button'}
      className={`  ${
        extraProps?.disabled || isPending
          ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
          : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
      } flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-base font-medium ${extraClasses}`}
    >
      {isPending && (
        <svg
          className="animate-spin h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
          />
        </svg>
      )}
      {icon}
      <span>{value}</span>
      {iconPosition === "end" && icon}
    </button>
  );
};

export default ButtonStyled;
